import { ApolloError, useQuery } from '@apollo/client'

import {
  Country,
  HasCountryNationalContractReferenceLevelQuery,
  HasCountryNationalContractReferenceLevelQueryVariables,
} from '../../../types'
import { HAS_COUNTRY_NATIONAL_CONTRACT_REFERENCE_LEVEL } from '../Queries'

export default function (country: Country): {
  data: HasCountryNationalContractReferenceLevelQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} {
  const variables = {
    country,
  }
  const { data, error, loading } = useQuery<
    HasCountryNationalContractReferenceLevelQuery,
    HasCountryNationalContractReferenceLevelQueryVariables
  >(HAS_COUNTRY_NATIONAL_CONTRACT_REFERENCE_LEVEL, {
    variables: variables,
  })

  return { data, error, loading }
}
